import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDate } from "@/constants/sports";
import { api } from "@/lib/api";

export const AlertsBell = () => {
  const [data, setData] = useState({ unread: 0, items: [] });
  const navigate = useNavigate();
  const load = useCallback(() => api.get("/alerts").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, [load]);
  const onOpen = (open) => {
    if (open && data.unread) api.post("/alerts/read").then(() => setData((d) => ({ ...d, unread: 0 })));
  };
  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="alerts-bell" aria-label="Alerts" className="relative rounded-full p-1.5 text-slate-300 transition-colors duration-200 hover:text-white">
          <Bell className="h-4 w-4" />
          {data.unread > 0 && (
            <span data-testid="alerts-unread-count" className="absolute -right-1 -top-1 min-w-[18px] rounded-full bg-[#FF2D78] px-1 text-center font-data text-[10px] font-bold leading-[18px] text-white">
              {data.unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 border-slate-800 bg-[#131927] p-0">
        <div className="flex items-center justify-between border-b border-slate-800 px-4 py-3">
          <span className="eyebrow">Alerts</span>
          <Link to="/saved" data-testid="alerts-manage-link" className="font-data text-[10px] uppercase tracking-wider text-slate-400 hover:text-[#FF2D78]">Saved searches</Link>
        </div>
        {!data.items.length && <p data-testid="alerts-empty" className="p-4 text-sm text-slate-500">No alerts yet. Save a search and we'll tell you when new players match.</p>}
        <div className="max-h-96 overflow-y-auto">
          {data.items.map((a) => (
            <button key={a.id} data-testid={`alert-item-${a.id}`} onClick={() => navigate(`/${a.params?.recipe ? "prototypes" : "players"}?${new URLSearchParams(a.params || {})}`)}
              className={`block w-full border-b border-slate-800/60 px-4 py-3 text-left transition-colors duration-200 hover:bg-[#0B0F19]/60 ${a.read ? "" : "bg-[#FF2D78]/5"}`}>
              <div className="text-sm text-white">{a.count} new player{a.count === 1 ? "" : "s"} match &ldquo;{a.search_name}&rdquo;</div>
              <div className="mt-0.5 truncate text-xs text-slate-400">{a.players.slice(0, 3).map((p) => p.name).join(", ")}{a.count > 3 ? "…" : ""}</div>
              <div className="mt-1 font-data text-[10px] text-slate-500">{fmtDate(a.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
